module.exports = __webpack_public_path__ + "assets/img/activity_auth.8f09fdb7.png";